module.exports = __webpack_public_path__ + "static/media/sound2.3680d118.mp3";